import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@components/ui/Button";
import RunsTab from "@components/agent-tests/RunsTab";
import ScenariosTab from "@components/agent-tests/ScenariosTab";
import { useAgentSimRuns } from "@hooks/useAgentSimRuns";

export default function AdminAgentTests() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("RUNS");
  const runs = useAgentSimRuns();

  const runOnClinic = async ({ clinicId, purpose }) => {
    await runs.triggerRun({ clinicId, purpose });
    runs.setFilter("clinicId", clinicId);
    await runs.refresh({ clinicId, status: "", onlyFailed: false });
    setTab("RUNS");
  };

  return (
    <div className="p-4 sm:p-6 space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <Button color="light" onClick={() => navigate(-1)}>← Back</Button>
          <div>
            <h1 className="text-lg sm:text-xl font-semibold">Admin: Agent Tests</h1>
            <p className="text-xs sm:text-sm text-gray-500">Monitor simulation runs and manage test scenarios.</p>
          </div>
        </div>
        {/* Segmented tab control */}
        <div className="inline-flex rounded-lg border border-gray-200 bg-gray-100 p-0.5">
          <button
            type="button"
            onClick={() => setTab("RUNS")}
            className={`px-4 py-1.5 text-sm font-medium rounded-md transition ${
              tab === "RUNS" ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Runs
          </button>
          <button
            type="button"
            onClick={() => setTab("SCENARIOS")}
            className={`px-4 py-1.5 text-sm font-medium rounded-md transition ${
              tab === "SCENARIOS" ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Scenarios
          </button>
        </div>
      </div>

      <p className="text-xs text-gray-500">
        {tab === "RUNS"
          ? "Runs — past and in-progress simulation runs (triggered by config edits or manually). Click a row for the transcript and per-scenario verdicts."
          : "Scenarios — the test cases generated per clinic & purpose. Review them, or run a fresh simulation on a clinic on demand."}
      </p>

      {tab === "RUNS" ? <RunsTab hook={runs} /> : <ScenariosTab clinics={runs.clinics} triggerRun={runOnClinic} />}
    </div>
  );
}
